import Header from "../Profile/components/Header";
import Footer from "../StaticPages/Footer";

function Layout({ children }) {
	return (
		<>
			<Header />

			{children}

			<div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
				<div className="rounded-3xl overflow-hidden">
					<Footer />
				</div>
			</div>
		</>
	);
}

export default Layout;
